<template>
<div>
  <div class="container">
    <Breadcrumbs />
    <div class='row'>
      <div class ='col-12 dBtn'>
        <q-btn data-cy='bNewCity' @click="goToCityDetail()" unelevated class='bPrincipal'>CREAR NUEVO MUNICIPIO</q-btn>
      </div>
    </div>
    <div class="row"></div>
    <div class="row col-12">
      <div class="col-12">
        <ListadoCiudades :isLoading="isLoading"/>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import ListadoCiudades from '../components/ListadoCiudades.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    ListadoCiudades,
    Breadcrumbs
  },
  mixins: [Message, Validation, Loading],
  async created () {
    this.showLoading();
    await this.$store.dispatch(types.ACTION_GET_ALL_CIUDADES).finally(() => {
      this.hideLoading();
      this.isLoading = false;
    });
  },
  data: function () {
    return {
      isLoading: true
    };
  },
  methods: {
    goToCityDetail () {
      this.$store.commit(types.MUTATE_CIUDAD, null);
      this.$router.push({ name: 'form_new_ciudad' });
    }
  }
};
</script>
<style lang="scss" scoped>
.bPrincipal{
  float: right;
}
.dBtn{
  margin-bottom: 15px;
}

</style>
